module.exports = __webpack_public_path__ + "static/media/becomeAHost.b5827144.svg";